import { useHttp } from '@/plugins/http/src/index'

export interface PicQueryParams {
  loginName: string
}

export interface CheckPicParams {
  code: string,
  loginName: string
}

export interface Response {
  [name: string]: any
}

export interface ResetParams {
  password: string;
  userName?: string;
  invitationCode?: string;
}

const base = '/api/air8-auth-center'
const path = process.env.VUE_APP_CLIENT_ADDRESS + '/reset-pwd'

export function getPic (params: PicQueryParams):Promise<any> {
  const { http } = useHttp()
  const data = {
    ...params,
    type: '1',
    code: '0'
  }
  return http.post<Response>(`${base}/sliderImage/getPic`, data)
}

export function checkCapCode (params: CheckPicParams) {
  const { http } = useHttp()
  const data = {
    ...params,
    type: '1'
  }
  return http.post<Response>(`${base}/sliderImage/checkCapCode`, data)
}

// 获取数字验证码
// export function getNumImg (params: PicQueryParams):Promise<any> {
//   const { http } = useHttp()
//   const data = {
//     ...params,
//     type: '1',
//     code: '0'
//   }
//   return http.post<Response>(`${base}/numImage/getNumPic`, data)
// }
export function getNumImg () {
  const { http } = useHttp()
  const data = {
    type: '1',
    code: '0'
  }
  return http.post<Response>(`${base}/numImage/getNumPic`, data)
}

// 校验数字验证码
export function checkNumImg (params: PicQueryParams):Promise<any> {
  const { http } = useHttp()
  const data = {
    ...params,
    type: '1'
  }
  return http.post<Response>(`${base}/numImage/checkCapCode`, data)
}

export function sendEmail (params: any) {
  const { http } = useHttp()
  return http.post<Response>(`${base}/email/sendMail`, params)
}

export function sendValidity (code: string) {
  const { http } = useHttp()
  return http.post<Response>(`${base}/email/expire?invitationCode=${code}`)
}

export function resetPwd (params: ResetParams) {
  const { http } = useHttp()
  return http.post<Response>(`${base}/email/update`, params)
}

export function simulateLogin (companyCode: string): Promise<Response> {
  const { http } = useHttp()
  return http.get<Response>(`${base}/login/simulate`, { params: { companyCode } })
}

export function queryLoginUser (): Promise<Response> {
  const { http } = useHttp()
  const token = JSON.parse(localStorage.getItem('authentication') || '{}')?.token
  const appId = process.env.VUE_APP_APP_ID
  return http.get<Response>(`${base}/login/login/user`, {
    showError: false,
    params: { token, appId }
  })
}

export function preview (url: string) {
  url = process.env.VUE_APP_PREVIEW_URL + window.location.origin + '/' + url
  window.open(url)
}
